document.addEventListener("DOMContentLoaded", () => {
  
    
  const bookDemoLinks = document.querySelectorAll(".bookademo");
  const modalClose = document.querySelector(".modal .modal-close");
  const modal = document.querySelector(".modal");
  if (bookDemoLinks.length > 0 && modalClose) {
    bookDemoLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.add("modal-open");
      });
    });
    modalClose.addEventListener("click", () => {
      document.body.classList.remove("modal-open");
    });
    

    document.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        document.body.classList.remove("modal-open");
      }
    });
  }

});